<template lang='pug'>
v-jumbotron
  v-container(fill-height)
    v-layout(align-center)
      v-flex
        v-alert(
          :value='errors.has("common")'
          color='error'
          icon='warning'
          class='mb-3'
          outline
        ) {{ errors.first("common") }}
        h3(class="display-3") Подтверждение телефонного номера
        span(class="subheading") Кто-то, возможны не вы бла-бла-бла
        div(class='mt-5 mb-2')
          v-text-field(
            large
            name='confirm_code'
            v-model='confirm_code'
            :error='errors.has("confirm_code")'
            :error-messages='errors.first("confirm_code")'
            label='Введите код, полученный по СМС'
            type='text'
          )
          v-layout
            v-spacer
            v-btn(large flat @click='$router.push({ name: "Index" })')
              v-icon(left) keyboard_backspace
              span Вернуться на главную
            v-btn(large color='primary' :loading='loading' @click='tryConfirm')
              | Подтвердить
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    id: {
      type: String
    }
  },

  data: () => ({
    loading: false,
    confirm_code: ''
  }),

  methods: {
    tryConfirm() {
      this.loading = true

      this.confirm({
        confirm_code: this.confirm_code,
        phone: this.id
      })
        .then(() => {
          this.$router.push({
            name: 'Index'
          })
        })
        .catch(this.$showServerErrors)
    },

    ...mapActions('auth', ['confirm'])
  }
}
</script>
